<template>
  <app-admin>
    <div class="container content clearfix">
      <loader ref="loader"/>

      <h1>Добавление участника в группу <span v-if="group">{{group.name}}</span></h1>

      <div class="no-players" v-if="filter.length==0 && showOnlyInGroup==false && this.players.length==0">
        <div class="text">
          У Вас пока нет ни одного созданного участника.
          <br>
          Добавьте нового участника
        </div>
        <router-link :to="{name: 'NewPlayer'}">
          <div class="btn btn-lg">
            Добавить нового участника
          </div>
        </router-link>
      </div>
      <div v-else>
        <div class="flex-between">
          <div class="search-wrap">
            <app-search @change="handleFilter" debounce="500"/>
          </div>
          <div class="checkbox-wrapper">
            <input v-model="showOnlyInGroup" @change="changeShowOnlyInGroup" type="checkbox" class="checkbox"
                   id="showPlayers"> <label for="showPlayers">Показать только участников группы</label>
          </div>
        </div>

        <table cellspacing="0" cellpadding="0" class="main-table">
          <thead>
          <tr>
            <th>№</th>
            <th>В группе</th>
            <th>ФИО участника</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="filter.length!=0 && players.length==0">
            <td class="text-center" colspan="5"><em>По вашему запросу ничего не найдено</em></td>
          </tr>
          <tr v-for="(player, index) in players" :key="player.id">
            <td style="width: 40px;">{{(itemsPerPage*(currentPage-1)) + index+1}}</td>
            <td style="width: 60px;" class="text-center">
              <font-awesome-icon icon="check" v-if="checkIfInGroup(player)" class="primary"/>
            </td>
            <td>
              {{player.last_name}} {{player.first_name}} {{player.middle_name}}
            </td>
            <td>
              <div class="btn" v-show="!checkIfInGroup(player)" @click="addToGroup(player)">Добавить в группу</div>
              <div class="btn btn-light" v-show="checkIfInGroup(player)" @click="removeFromGroup(player)">Удалить из
                группы
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <pagination @change="setPage" :itemsPerPage="itemsPerPage" :resultCount="resultCount" ref="pagination"/>

        <div class="buttons">
          <router-link :to="{name: 'Group', params: { id: group.id }}">
            <div class="btn btn-light">Назад к группе</div>
          </router-link>
        </div>
      </div>
    </div>
  </app-admin>
</template>

<script>
  import GroupsService from '@/services/GroupsService'
  import PlayersService from '@/services/PlayersService'

  export default {
    name: 'GroupPlayers',
    data () {
      return {
        filter: '',
        group: {
          name: '',
          theme: {
            name: ''
          }
        },
        players: [],
        playersInGroup: [],
        showOnlyInGroup: false,
        currentPage: 1,
        itemsPerPage: 10,
        resultCount: 0
      }
    },
    methods: {
      handleFilter: function (filter) {
        this.filter = filter
        if (!this.showOnlyInGroup) {
          this.getPlayers()
        } else {
          // фильтр по чувакам в группе
          this.players = this.playersInGroup.filter((player) => {
            let fio = player.last_name + ' ' + player.first_name + ' ' + player.middle_name
            return fio.toLowerCase().includes(filter.toLowerCase())
          })
        }
      },
      checkIfInGroup (player) {
        return this.playersInGroup.filter(x => x.id === player.id).length > 0
      },
      removeFromGroup (player) {
        PlayersService.removePlayerFromGroup(this.group.id, player.id).then(
          (response) => {
            let playerIndex = this.playersInGroup.findIndex(x => x.id === player.id)
            this.playersInGroup.splice(playerIndex, 1)
          }
        )
      },
      addToGroup (player) {
        PlayersService.addPlayerToGroup(this.group.id, player.id).then(
          (response) => {
            this.playersInGroup.push(player)
          }
        )
      },
      setPage (pageNumber) {
        this.currentPage = pageNumber
        if (!this.showOnlyInGroup) {
          this.getPlayers()
        } else {
          // пагинация чуваков в группе
          let index = this.currentPage * this.itemsPerPage - this.itemsPerPage
          this.players = this.playersInGroup.slice(index, index + this.itemsPerPage)
        }
      },
      getPlayers () {
        PlayersService.getPlayers(this.currentPage, this.itemsPerPage, this.filter).then(
          (response) => {
            this.players = response.results
            this.resultCount = response.count
          },
          (error) => {
            console.log(error)
          }
        )
      },
      changeShowOnlyInGroup () {
        this.currentPage = 1
        this.$refs.pagination.setPage(1)
        if (this.showOnlyInGroup) {
          let index = this.currentPage * this.itemsPerPage - this.itemsPerPage
          this.players = this.playersInGroup.slice(index, index + this.itemsPerPage)
          this.resultCount = this.playersInGroup.length
        } else {
          this.players = this.getPlayers()
        }
      }
    },
    computed: {},
    mounted () {
      let id = this.$route.params.id
      GroupsService.getGroup(id).then(
        (response) => {
          this.group = response
        },
        (error) => console.log(error)
      )
      this.$refs.loader.show()
      PlayersService.getPlayersByGroupId(id).then(
        (response) => {
          this.playersInGroup = response
          this.$refs.loader.hide()
        },
        (error) => console.log(error)
      )

      this.getPlayers()
    }
  }
</script>

<style scoped lang="scss">
  table {
    td {
      padding-top: 5px !important;
      padding-bottom: 5px !important;;
    }
    .btn {
      text-align: center;
      padding: 10px 0px;
      box-sizing: border-box;
      width: 145px;
      font-size: 14px;
    }
  }

  .no-players {
    margin-top: 150px;
    text-align: center;
    .text {
      color: #666666;
      font-weight: 300;
      font-size: 1.5em;
      line-height: 2em;
      margin-bottom: 20px;
    }
  }

  .primary {
    color: $blue;
  }

  .content {
    padding-bottom: 50px;
  }

  .buttons {
    position: absolute;
    padding: 15px 20px;
    left: 0;
    bottom: 0;
  }

  .search-wrap {
    flex: 1;
    margin-right: 40px;
  }

  .checkbox-wrapper {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/groups/GroupPlayers.vue